var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 13V8.5C21.25 7.17392 20.7232 5.90215 19.7855 4.96447C18.8479 4.02678 17.5761 3.5 16.25 3.5H7.75C6.42392 3.5 5.15215 4.02678 4.21447 4.96447C3.27678 5.90215 2.75 7.17392 2.75 8.5V15.5C2.75 16.1566 2.87933 16.8068 3.1306 17.4134C3.38188 18.02 3.75017 18.5712 4.21447 19.0355C5.15215 19.9732 6.42392 20.5 7.75 20.5H14.01",
    stroke: "#D0D0D0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00781 17.0016L5.74781 13.8016C6.10765 13.4442 6.57992 13.2221 7.08469 13.1729C7.58946 13.1237 8.09573 13.2504 8.51781 13.5316C8.9399 13.8128 9.44616 13.9395 9.95093 13.8903C10.4557 13.8411 10.928 13.619 11.2878 13.2616L13.6178 10.9316C14.2873 10.2598 15.1737 9.8478 16.1188 9.76904C17.064 9.69028 18.0064 9.9499 18.7778 10.5016L21.2478 12.4116M8.00781 10.1716C8.22581 10.1703 8.44141 10.126 8.64231 10.0414C8.8432 9.95677 9.02546 9.83339 9.17868 9.67832C9.3319 9.52325 9.45307 9.33951 9.53528 9.13761C9.61749 8.93571 9.65913 8.71959 9.65781 8.50159C9.6565 8.2836 9.61226 8.068 9.52763 7.8671C9.44299 7.6662 9.31961 7.48394 9.16454 7.33072C9.00946 7.17751 8.82573 7.05634 8.62383 6.97413C8.42192 6.89192 8.20581 6.85028 7.98781 6.85159C7.54755 6.85424 7.12638 7.03168 6.81694 7.34487C6.50751 7.65805 6.33516 8.08133 6.33781 8.52159C6.34046 8.96185 6.5179 9.38303 6.83109 9.69246C7.14427 10.0019 7.56755 10.1742 8.00781 10.1716Z",
    stroke: "#D0D0D0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.707 15V20",
    stroke: "#D0D0D0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 17.1064L19.0331 15.1394C18.9903 15.0964 18.9395 15.0624 18.8836 15.0391C18.8276 15.0159 18.7676 15.0039 18.7071 15.0039C18.6465 15.0039 18.5865 15.0159 18.5306 15.0391C18.4746 15.0624 18.4238 15.0964 18.3811 15.1394L16.4141 17.1064",
    stroke: "#D0D0D0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectLogo);
export default __webpack_public_path__ + "static/media/select_logo.98a0372ccfce9b0196ccf0e393971c4b.svg";
export { ForwardRef as ReactComponent };